import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
import BrandLogo from '../components/brand/BrandLogo';
import { useAuth } from '../lib/auth';
import { toast } from 'sonner';
import AuthFooter from '../components/shared/AuthFooter';

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('ramesh@fabtexs.demo');
  const [password, setPassword] = useState('Demo@1234');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Welcome back!');
      nav('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Invalid credentials');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen mesh-bg flex items-center justify-center p-4 sm:p-6">
      <div className="w-full max-w-md fade-up">
        <Link to="/" className="flex items-center justify-center mb-6 sm:mb-8" data-testid="brand-link">
          <BrandLogo height={38} />
        </Link>
        <div className="fab-card p-5 sm:p-8">
          <h1 className="font-display text-2xl font-bold text-fab-text">Welcome back</h1>
          <p className="text-[13px] text-fab-text-secondary mt-1">Sign in to continue running your textile business.</p>
          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <div>
              <label className="text-[12px] font-semibold text-fab-text-secondary">Email or Mobile</label>
              <input
                type="text" value={email} onChange={(e) => setEmail(e.target.value)}
                className="fab-input mt-1.5 w-full px-3.5 py-2.5 rounded-lg border border-fab-primary-lighter text-[14px]"
                data-testid="email-input" required
              />
            </div>
            <div>
              <label className="text-[12px] font-semibold text-fab-text-secondary">Password</label>
              <div className="relative mt-1.5">
                <input
                  type={show ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)}
                  className="fab-input w-full px-3.5 py-2.5 pr-10 rounded-lg border border-fab-primary-lighter text-[14px]"
                  data-testid="password-input" required
                />
                <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-fab-text-muted">
                  {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full py-2.5" data-testid="login-submit">
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
            <div className="text-center mt-1">
              <Link to="/forgot-password" data-testid="forgot-password-link" className="text-[13px] text-fab-primary font-semibold hover:underline">
                Forgot password?
              </Link>
            </div>
            <div className="text-[12px] text-center text-fab-text-secondary mt-2">
              Demo: <span className="font-mono text-fab-primary">ramesh@fabtexs.demo</span> / <span className="font-mono text-fab-primary">Demo@1234</span>
            </div>
            <p className="text-center text-[13px] text-fab-text-secondary">
              No account? <Link to="/signup" className="text-fab-primary font-semibold">Start free trial</Link>
            </p>
          </form>
        </div>
        <AuthFooter />
      </div>
    </div>
  );
}
